module.exports = __webpack_public_path__ + "img/9.6505e17e.png";